import {Injectable} from '@angular/core';
import {NeoStorageService, Utils} from "ng-neo/index";

@Injectable()
export class NeoOfflineService {

    constructor(
        private _storage: NeoStorageService
    ) {}


    /**
     * Comprueba si tiene informacion guardada que no se ha podido enviar a la api
     *
     * @param key
     * @param lastUpdate
     */
    hasInfoToRestore(key: string, lastUpdate: string): boolean {
        const info = this._storage.existsInLocalStorage(key) &&
            !Utils.isEmpty(this._storage.getFromLocalStorage(key)) && lastUpdate &&
            new Date(this._storage.getFromLocalStorage(key).date) > new Date(lastUpdate);

        if (info) {
            return true
        }

        this._storage.removeFromLocalStorage(key);
        return false;
    }

    /**
     * Guarda los datos
     *
     * @param {string} key
     * @param data
     */
    saveData(key: string, data: any) {
        this._storage.setToLocalStorage(key, {data, date: (new Date()).toString()});
    }

    /**
     * Obtencion de los datos guardados
     *
     * @param {string} key
     * @param {string} lastUpdate
     * @returns {any}
     */
    getData(key: string, lastUpdate: string = null) {
        if (lastUpdate && !this.hasInfoToRestore(key, lastUpdate)) {
            return null
        }

        return this._storage.getFromLocalStorage(key).data;
    }

    /**
     * Obtencion de los datos guardados una vez
     *
     * @param {string} key
     * @param {string} lastUpdate
     * @returns {any}
     */
    getDataOnce(key: string, lastUpdate: string = null) {
        let data = this.getData(key, lastUpdate);

        this.deleteData(key);

        return data;
    }


    deleteData(key: string) {
        this._storage.removeFromLocalStorage(key);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-offline/neo-offline.service.ts